module.exports = __webpack_public_path__ + "static/71invgde-1b33dc98c55ea00952aa74db34a3331a.gif";